var map = {
	"./AU": 4468,
	"./AU.js": 4468,
	"./BE": 4211,
	"./BE.js": 4211,
	"./CA": 118,
	"./CA.js": 118,
	"./CN": 6783,
	"./CN.js": 6783,
	"./DE": 9753,
	"./DE.js": 9753,
	"./GB": 3863,
	"./GB.js": 3863,
	"./HK": 5999,
	"./HK.js": 5999,
	"./JP": 9320,
	"./JP.js": 9320,
	"./KR": 7547,
	"./KR.js": 7547,
	"./MY": 7228,
	"./MY.js": 7228,
	"./NL": 824,
	"./NL.js": 824,
	"./NZ": 6910,
	"./NZ.js": 6910,
	"./SG": 3472,
	"./SG.js": 3472,
	"./TH": 4766,
	"./TH.js": 4766,
	"./TW": 5767,
	"./TW.js": 5767,
	"./US": 5257,
	"./US.js": 5257,
	"./default": 4797,
	"./default.js": 4797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8554;